import graphql__c7a991b547a333e3e593 from "./__generated__/AudioPlayer_audio.graphql.js";import { graphql, useFragment } from "react-relay";
import ReactPlayer from "react-player/file";

const AudioPlayer = ({ ...props }) => {
  const { url } = useFragment(AudioPlayer_audio, props.audio);

  return <ReactPlayer url={url} controls className="audio-player" />;
};

const AudioPlayer_audio = graphql__c7a991b547a333e3e593;

export default AudioPlayer;
